import React from 'react'
import { ModalInjectedProps } from 'containers/ModalManager'
import Modal from 'components/Modal'
import UserChip from '../../components/UserChip'
import SignInWithPasswordForm from './SignInWithPasswordForm'

export interface OnlySignInWithPasswordModalProps {
  workspaceName: string
  name: string
  email: string
  avatarSrc?: string
  onCompleted?: () => void
}

type SignInWithPasswordModalProps = OnlySignInWithPasswordModalProps &
  ModalInjectedProps

const SignInWithPasswordModal: React.FC<SignInWithPasswordModalProps> = ({
  workspaceName,
  name,
  email,
  avatarSrc,
  onCompleted,
  hideModal,
}) => {
  return (
    <Modal
      title={`Sign in to "${workspaceName}" Workspace`}
      onCancel={hideModal}>
      <Modal.Body>
        <UserChip name={name} email={email} avatarSrc={avatarSrc} />
        <SignInWithPasswordForm
          email={email}
          onCompleted={() => {
            hideModal()
            onCompleted?.()
          }}
        />
      </Modal.Body>
    </Modal>
  )
}

export default SignInWithPasswordModal
